module.exports = __webpack_public_path__ + "img/base-spring.67923477.png";